//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import nutritionists from '~~/data/content/nutritionists.json'

export default {
  name: 'NutritionistsDisplay',

  props: {
    filter: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      selected: null
    }
  },

  computed: {
    nutritionists() {
      if (this.filter === 'homepage') {
        return nutritionists.filter(i => i.isPublished && i.showOnHomePage)
      }

      return nutritionists.filter(i => i.isPublished)
    },

    selectedNutritionist() {
      return this.nutritionists[this.selected] || {}
    },

    showModal() {
      return Boolean(Object.keys(this.selectedNutritionist).length)
    }
  }
}
